// Copyright (c) 2016 HVIKT AS
(function() {
    'use strict';

    angular.module('app').config(routes);
    angular.module('app').config(delegateProvider);

    angular.module('app').config(decorateState);
    //angular.module('app').config(decorateStateWithResolve);
    routes.$inject = ['$stateProvider', '$urlRouterProvider'];
    delegateProvider.$inject = ['$sceDelegateProvider'];
    decorateState.$inject = ['$provide'];


    function routes($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('main',
                {
                    url: '/',
                    views: {
                        'main': {
                            template: require('./main/main.html'),
                            controller: 'mainController',
                            controllerAs: 'vm'
                        }
                    }
          })
          .state('register',
            {
              url: '/register',
              views: {
                'main': {
                  template: require('./login/register.html'),
                  controller: 'registerController',
                  controllerAs: 'vm'
                }
              }
          })
          .state('reset',
            {
              url: '/resetPassword/:tp1/:tp2/:tp3',
              views: {
                'main': {
                  template: require('./login/resetPassword.html'),
                  controller: 'resetPasswordController',
                  controllerAs: 'vm'
                }
              }
            })
            .state('list',
                {
                    url: '/list/:name',
                    views: {
                        'main': {
                            template: require('./list/list.html'),
                            controller: 'listController',
                            controllerAs: 'vm'
                        }
                    } 
            })
            .state('admin', {
                abstract: true,
                url: '/admin',
                views: {
                    'main': {
                        template: require('./admin/admin.html'),
                        controller: 'adminController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('admin.usersList', {
                url: '/users',
                views: {
                    'admin': {
                        template: require('./users/usersList.html'),
                        controller: 'usersListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    auth: [
                        "auth", function (auth) {
                            return auth.isAuthenticated();
                        }
                    ]
                }
            })
            .state('admin.users', {
                url: '/users/:usersId',
                views: {
                    'admin': {
                        template: require('./users/users.html'),
                        controller: 'usersController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    auth: [
                        "auth", function (auth) {
                            return auth.isAuthenticated();
                        }
                    ]
                }
            })
            .state('admin.stat',
                {
                    url: '/stat',
                    views: {
                        'admin': {
                            template: require('./stat/stat.html'),
                            controller: 'statController',
                            controllerAs: 'vm'
                        }
                    }
                })
            .state('admin.personList',
                {
                    url: '/person/list',
                    views: {
                        'admin': {
                            template: require('./person/personList.html'),
                            controller: 'personListController',
                            controllerAs: 'vm'
                        }
                    }
                })
            .state('admin.person',
                {
                    url: '/person/:personId',
                    views: {
                        'admin': {
                            template: require('./person/person.html'),
                            controller: 'personController',
                            controllerAs: 'vm'
                        }
                    }
                })
            .state('admin.workplace',
                {
                    url: '/workplace/:workplaceId',
                    views: {
                        'admin': {
                            template: require('./workplace/workplace.html'),
                            controller: 'workplaceController',
                            controllerAs: 'vm'
                        }
                    }
            })
            .state('admin.workplaceList',
                {
                    url: '/workplace/list',
                    views: {
                        'admin': {
                            template: require('./workplace/workplaceList.html'),
                            controller: 'workplaceListController',
                            controllerAs: 'vm'
                        }
                    }
            })
            .state('admin.institution',
                {
                    url: '/institution/:institutionId',
                    views: {
                        'admin': {
                            template: require('./institution/institution.html'),
                            controller: 'institutionController',
                            controllerAs: 'vm'
                        }
                    }
            })
            .state('admin.institutionList',
                {
                    url: '/institution/list',
                    views: {
                        'admin': {
                            template: require('./institution/institutionList.html'),
                            controller: 'institutionListController',
                            controllerAs: 'vm'
                        }
                    }
            })
            .state('admin.group',
            {
                url: '/group/:networkGroupId',
                views: {
                    'admin': {
                        template: require('./group/group.html'),
                        controller: 'groupController',
                        controllerAs: 'vm'
                    }
                }
            }).state('admin.groupList',
            {
                url: '/group/list',
                views: {
                    'admin': {
                        template: require('./group/groupList.html'),
                        controller: 'groupListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('admin.network',
                {
                    url: '/network/:networkId',
                    views: {
                        'admin': {
                            template: require('./network/network.html'),
                            controller: 'networkController',
                            controllerAs: 'vm'
                        }
                    }
            }).state('admin.networkList',
                {
                    url: '/network/list',
                    views: {
                        'admin': {
                            template: require('./network/networkList.html'),
                            controller: 'networkListController',
                            controllerAs: 'vm'
                        }
                    }
            }).state('admin.codingSystem',
                {
                    url: '/codingSystem',
                    views: {
                        'admin': {
                            template: require('./codingSystem/codingSystem.html'),
                            controller: 'codingSystemController',
                            controllerAs: 'vm'
                        }
                    }
                });
        $urlRouterProvider.otherwise('/');
    };


    function delegateProvider($sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist(['self', '**']);

    }
    
    function decorateState($provide) {
        $provide.decorator('$state',
            ['$delegate', '$rootScope', function ($delegate, $rootScope) {
                $rootScope.$on('$stateChangeStart',
                    function (event, state, params) {
                        console.log(state);
                        $delegate.next = state;
                        $delegate.toParams = params;
                    });
                return $delegate;
            }]);
    };


})();